var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:_vm.computedClasses},'div',{ id: _vm.id },false),[_c('WidgetGroup',{attrs:{"widgets":_vm.children}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }